import {STOCK_DOCUMENT_STATUS, STOCK_DOCUMENT_TYPE, STOCK_IMPORT_STATUS} from "../../../../common/types/inventory"
import {STOCK_DOCUMENTS} from "../../../../utils/inventory"
import {ApiSupportSelector} from "../../../helpers/apiSupport"
import {InitialState} from "../reducers"
import {PricingRowDto} from "../../../pricing/PricingRow"

export const Selector = {
    get: (state): InitialState => {
        return state.inventory.stockDocument
    },

    getStructured: (state) => {
        return {
            id: Selector.getId(state),
            type: STOCK_DOCUMENTS,
            attributes: Selector.get(state)
        }
    },

    getId: (state) => {
        return Selector.get(state).id
    },

    getProposalHash: (state) => {
        return Selector.get(state).proposalHash
    },

    getDocumentStatus: (state) => {
        return Selector.get(state).status?.attributes.state
    },

    isDraft: (state) => {
        return Selector.get(state).status?.attributes.state === STOCK_DOCUMENT_STATUS.DRAFT ?? true
    },

    isInProgress: (state) => {
        return Selector.get(state).status?.attributes.state === STOCK_IMPORT_STATUS.IN_PROGRESS ?? true
    },

    isCompleted: (state) => {
        return Selector.get(state).status?.attributes.state === STOCK_IMPORT_STATUS.COMPLETED ?? true
    },

    getIdentifier: (state) => {
        return Selector.get(state).identifier
    },

    isArchived: (state) => {
        return Selector.get(state).deleted
    },

    getStatus: (state) => {
        return {
            id: Selector.get(state).status.id,
            ...Selector.get(state).status.attributes,
        }
    },

    getName: (state) => {
        return Selector.get(state).definition.attributes?.name ?? ""
    },

    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))
    },

    isFetching: (state) => {
        return Selector.get(state).isFetching
    },

    getEmailTemplateId: (state) => {
        return Selector.get(state).definition.attributes.emailTemplates[0]?.id ?? ""
    },

    getDirection: (state) => {
        return Selector.get(state).definition?.attributes?.direction
    },

    getAdjustmentIsLoading: (state) => {
        return Selector.get(state).isFetching
    },

    isPartiallyReceived: (state) => {
        const items = Selector.get(state).table.attributes.items
        const status = Selector.get(state).status?.attributes.state
        const documentType = Selector.get(state).definition?.attributes.name
        if (items === undefined || items.length == 0) {
            return false
        }
        let selectedItems : PricingRowDto[] = []
        if (documentType == STOCK_DOCUMENT_TYPE.PURCHASE_ORDER) {
            selectedItems = items.filter(function (item: PricingRowDto) {
                const measure = Number(item.attributes.measure)
                const received = Number(item.attributes.inventoryReceivedMeasure)
                if (received == measure || received == 0) {
                    return false
                } else {
                    return true
                }
            })
        }
        if (documentType == STOCK_DOCUMENT_TYPE.VENDOR_RETURN) {
            selectedItems = items.filter(function (item: PricingRowDto) {
                const measure = Number(item.attributes.measure)
                const sent = Number(item.attributes.inventorySentMeasure)
                if (sent == measure || sent == 0) {
                    return false
                } else {
                    return true
                }
            })
        }

        return status == STOCK_DOCUMENT_STATUS.IN_PROGRESS && selectedItems.length > 0

    },

    //StockDocumentFooter
    getFooterState: (state) => {
        return {
            proposalHash: Selector.get(state).proposalHash,
            isArchived: Selector.isArchived(state),
            isDraft: Selector.isDraft(state),
            isInProgress: Selector.isInProgress(state),
            isCompleted: Selector.isCompleted(state),
            direction: Selector.getDirection(state),
            emailTemplateId: Selector.getEmailTemplateId(state),
            isFetching: Selector.get(state).isFetching,
            includeContact: Selector.get(state).definition.attributes.includeContact,
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/selectors/selectors.ts